import React from 'react'
import CheckoutFormSection from './CheckoutFormSection'
import LocationSelect from '../../layout/Locations/LocationSelect'

const CheckoutFormLocationSelect = ({ checkout, onChange }) => {
    return (
        <CheckoutFormSection title='Local'>
            <LocationSelect onChange={onChange} value={checkout.location} />
        </CheckoutFormSection>
    )
}

export default CheckoutFormLocationSelect
